<!-- 由 suu 创建于 2022-08-30 星期二 -->
<template>
  <div class="sum-pie-chart">
    <div class="pc-left">
      <div class="l-item" v-for="(value, key, index) in datum" :key="index">
        <div class="i-title">{{ value.title }}</div>
        <div class="i-num">
          {{ value.done }}<span v-if="value.all">/{{ value.all }}</span>
        </div>
      </div>
    </div>
    <div id="result-chart"></div>
    <!-- <div class="pc-cent">
      <div class="c-item c-diet">
        <div class="c-item c-test"> 打卡率 </div>
      </div>
    </div> -->
  </div>
</template>

<script>
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
// import * as echarts from 'echarts'
export default {
  name: 'sum-pie-chart',

  components: {},

  props: {
    datum: {}
  },

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {
    this.initChart()
  },

  destroyed() {},

  methods: {
    initChart() {
      var diet = this.datum.diet.done,
        test = this.datum.test.done,
        dietTotal = this.datum.diet.all,
        testTotal = this.datum.test.all,
        dietRate = ((diet / dietTotal) * 100).toFixed(0),
        testRate = ((test / testTotal) * 100).toFixed(0)
      var option = {
        title: {
          text: '打卡率',
          left: '24%',
          top: 'center',
          textStyle: {
            fontSize: 12
          }
        },
        tooltip: {
          show: false,
          trigger: 'item',
          formatter: '{a} : {c} ({d}%)'
        },
        // color: ['#8E7DFF', '#FFACDF'],
        // color: ['rgb(255,159,127)', 'rgb(50,197,233)'],
        legend: {
          orient: 'vertical',
          x: '59%',
          top: '27%',
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8, //图例的高度
          itemGap: 20, //图例之间的间距
          textStyle: {
            fontWeight: 500
          },
          data: [
            '饮食打卡率: ' + dietRate + '%',
            '体测打卡率: ' + testRate + '%'
          ],
          //图例的名字需要和饼图的name一致，才会显示图例
          // formatter:function(val){ return val.split(": ")[0] + `\n${val.split(": ")[1]}`}
          formatter: function (val) {
            return [
              `{a|${val.split(': ')[0]}}`,
              `{b|${val.split(': ')[1]}}`
            ].join('\n')
          },
          textStyle: {
            //rich放在textStyle里面
            rich: {
              a: {
                fontSize: 10
              },
              b: {
                fontSize: 12,
                fontWeight: 800,
                padding: [4, 0, 0, 0]
              }
            }
          }
        },
        series: [
          {
            name: '饮食打卡率: ' + dietRate + '%',
            type: 'pie',
            radius: ['45%', '60%'],
            center: ['35%', '50%'],
            color: '#8E7DFF',
            //环的位置
            label: {
              show: false,
              position: 'center'
              // normal: { // 显示的位置
              //     position: 'inner'
              // }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            // labelLine: {
            //   normal: {
            //     length: 2,
            //     length2: 8,
            //     smooth: true,
            //     lineStyle: {
            //       color: '#8E7DFF'
            //     }
            //   }
            // },
            // label: {
            //   position: 'right',
            //   normal: {
            //     formatter: (params) => {
            //       return '{icon|●} 饮食打卡率' + '\n{value|' + dietRate + '%}'
            //     },
            //     // position: 'right',
            //     // padding: [0, -100, 25, -100],
            //     // offset: [30, 40],
            //     rich: {
            //       icon: {
            //         fontSize: 10,
            //         color: '#8E7DFF'
            //       },
            //       name: {
            //         fontSize: 10,
            //         padding: [0, 0, 0, 8],
            //         color: '#333'
            //       },
            //       value: {
            //         fontSize: 14,
            //         fontWeight: 'bold',
            //         padding: [4, 0, 0, 15],
            //         color: '#000'
            //       }
            //     }
            //   }
            // },
            itemStyle: {
              borderRadius: '50%'
            },
            data: [
              {
                value: diet, //需要显示的数据
                name: '饮食: ' + diet + '%',
                itemStyle: {
                  normal: {
                    // color: 'rgb(255,159,127)'
                  }
                }
              },
              {
                value: dietTotal - diet,
                //不需要显示的数据，颜色设置成和背景一样
                itemStyle: {
                  normal: {
                    // color: ''
                    color: diet ? 'transparent' : '#f2f1ff'
                  }
                }
              }
            ]
          },
          {
            name: '体测打卡率: ' + testRate + '%',
            type: 'pie',
            color: '#FFACDF',
            radius: ['30%', '45%'],
            center: ['35%', '50%'],
            label: {
              show: false,
              position: 'center'
              // normal: {
              //     position: 'inner'
              // }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            itemStyle: {
              borderRadius: '50%'
            },
            data: [
              {
                name: '体测: ' + testRate + '%',
                value: test,
                itemStyle: {
                  normal: {
                    // color: 'rgb(50,197,233)'
                  }
                }
              },
              {
                value: testTotal - test,
                itemStyle: {
                  normal: {
                    color: test ? 'transparent' : '#e7e7fe'
                    // color: ''
                  }
                }
              }
            ]
          }
        ]
      }
      var chartDom = document.getElementById('result-chart')
      var myChart = this.$parent.echarts.init(chartDom, null, {
        renderer: 'svg'
      })
      option && myChart.setOption(option)
    }
  }
}
</script>

<style lang="scss" scoped>
.sum-pie-chart {
  width: 100%;
  box-sizing: border-box;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #000;
  height: 140px;
  overflow: hidden;
  .pc-left {
    // margin-bottom: -15px;
    .l-item {
      display: flex;
      align-items: center;
      & + .l-item {
        margin-top: 8px;
      }
      .i-title {
        font-size: 12px;
      }
      .i-num {
        display: flex;
        align-items: baseline;
        justify-content: center;
        margin-left: 8px;
        font-size: 16px;
        font-weight: 600;
        span {
          font-size: 14px;
          opacity: 0.5;
        }
      }
    }
  }
  #result-chart {
    width: 200px;
    // flex: 1;
    height: 160px;
  }
  .pc-cent {
    margin-left: 28px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    .c-item {
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
    }
    .c-diet {
      width: 90px;
      height: 90px;
      border: 12px solid #8e7dff;
    }
    .c-test {
      width: 68px;
      height: 68px;
      border: 12px solid #ffacdf;
      font-size: 10px;
      font-weight: 500;
    }
  }
}
</style>
